var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sow-view-containter", attrs: { id: "sow-view-content" } },
    [
      _c(
        "ul",
        {
          staticClass: "accordion",
          attrs: {
            id: _vm.sowAccordionId,
            "data-accordion": "",
            "data-deep-link": "true",
            "data-allow-all-closed": "true",
            "data-multi-expand": "true",
            "data-update-history": "true",
            "data-deep-link-smudge": "500",
          },
        },
        [
          _c(
            "li",
            {
              staticClass: "accordion-item is-active",
              attrs: { "data-accordion-item": "" },
            },
            [
              _c("a", { staticClass: "accordion-title" }, [
                _vm._v(_vm._s(_vm.$t("tender.sow.generalDesc"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "accordion-content email-preview",
                  attrs: { id: "deeplink1", "data-tab-content": "" },
                },
                [
                  _c("div", {
                    staticClass: "email-preview__content",
                    class: _vm.highlightAddendumChange("generalDesc"),
                    domProps: {
                      innerHTML: _vm._s(_vm.scopeOfWorks.generalDesc),
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "accordion-item is-active",
              attrs: { "data-accordion-item": "" },
            },
            [
              _c("a", { staticClass: "accordion-title" }, [
                _vm._v(_vm._s(_vm.$t("tender.sow.generalSpec"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "accordion-content email-preview",
                  attrs: { id: "deeplink2", "data-tab-content": "" },
                },
                [
                  _c("div", {
                    staticClass: "email-preview__content",
                    class: _vm.highlightAddendumChange("generalSpec"),
                    domProps: {
                      innerHTML: _vm._s(_vm.scopeOfWorks.generalSpec),
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "accordion-item is-active",
              attrs: { "data-accordion-item": "" },
            },
            [
              _c("a", { staticClass: "accordion-title" }, [
                _vm._v(_vm._s(_vm.$t("tender.sow.partiSpec"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "accordion-content email-preview",
                  attrs: { id: "deeplink3", "data-tab-content": "" },
                },
                [
                  _c("div", {
                    staticClass: "email-preview__content",
                    class: _vm.highlightAddendumChange("particularDesc"),
                    domProps: {
                      innerHTML: _vm._s(_vm.scopeOfWorks.particularDesc),
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "accordion-item is-active",
              attrs: { "data-accordion-item": "" },
            },
            [
              _c("a", { staticClass: "accordion-title" }, [
                _vm._v(_vm._s(_vm.$t("tender.sow.techSpec"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "accordion-content email-preview",
                  attrs: { id: "deeplink4", "data-tab-content": "" },
                },
                [
                  _c("div", {
                    staticClass: "email-preview__content",
                    class: _vm.highlightAddendumChange("technicalDesc"),
                    domProps: {
                      innerHTML: _vm._s(_vm.scopeOfWorks.technicalDesc),
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }